import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { LinkedContactsDetailsModel, LinkedContactsRowModel } from './linked-contacts.model';

@Injectable({
    providedIn: 'root'
})
export class LinkedContactsService {

    constructor(
        private cvApiService: CVApiService
    ) {

    }

    public async loadData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `${renderEndpoint}/api/v2/dashboards/modules/linked-contacts/${moduleKey}?
                isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<LinkedContactsRowModel[]>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }
    }

    public async loadDetails(moduleKey: string, masterContactID: string, linkedContactId: string) {
        try {
            const url = `/api/v2/dashboards/modules/linked-contacts/details/${moduleKey}/${masterContactID}/${linkedContactId || 'empty'}`;
            const response = await this.cvApiService.get<LinkedContactsDetailsModel>(url);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error("Failed getting contact details");
            throw err;
        }
    }

    public async loadDataForExport(moduleKey: string, format) {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);

        } catch (error) {
            console.error("Failed getting render endpoint");
            throw error;
        }

        const url = `/api/v2/dashboards/modules/linked-contacts/${moduleKey}/export?format=${format}`;
        try {
            const response = await this.cvApiService.get<string>(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            else
                return response;
        } catch (error) {
            console.error("Failed getting linked contacts data for export.");
            throw error;
        }
    }
}
